
const downLoadUpLoad = r => require.ensure([], () => r(require('@/page/downLoadUpLoad/downLoadUpLoad')), 'downLoadUpLoad');
const upLoad = r => require.ensure([], () => r(require('@/page/downLoadUpLoad/upLoad')), 'upLoad');


const downLoadUpLoadRouter = {
  path: '',
  component: downLoadUpLoad,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
  },
  name: '上传下载空白页面',
  redirect: '/index',
  children: [{
      path: '/upLoad',
      component: upLoad,
      name: '上传页面',
      meta: {
        right: ['上传页面'],
        isShowMenu: true
      }
    }
  ]
};

export default downLoadUpLoadRouter;